import { SelectableTagWrapper } from './styles';
import { TruncateText } from './styles';
import { Body7 } from '@ui';
import React from 'react';

export const SelectableTagResult = ({ value, onClick, isSelected }) => {
  const { company_id, name, symbol } = value;

  const handleClick = () => {
    onClick(value);
  };

  const text = symbol === null ? name : `${symbol} - ${name}`;
  return (
    <SelectableTagWrapper isSelected={isSelected} onClick={handleClick}>
      <TruncateText>
        <Body7>{text}</Body7>
      </TruncateText>
    </SelectableTagWrapper>
  );
};
